import { Check, X, Beaker, GraduationCap, Users, Database, Cpu, Shield, Clock, HeadphonesIcon } from 'lucide-react';
import { Badge } from './ui/badge';
import { Button } from './ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import React from 'react';
import { useNavigate } from 'react-router-dom'; 

export function VersionComparison() {
  const navigate = useNavigate();
  const features = [
    {
      name: "文件",
      children: [
        {
          name: "镜头文件",
          children: [
            { name: "新建", pro: true, free: true },
            { name: "打开", pro: true, free: true },
            { name: "保存", pro: true, free: true },
            { name: "另存为", pro: true, free: true },
            { name: "插入镜头", pro: true, free: "●" }
          ]
        },
        {
          name: "输出文件",
          children: [
            { name: "CAD文件", pro: true, free: "●" },
            { name: "输出2D DXF图元文件", pro: true, free: "●" },
            { name: "输出3D DXF图元文件", pro: true, free: "●" },
            { name: "输出IGES图元文件", pro: true, free: "●" },
            { name: "自动绘图", pro: true, free: true }
          ]
        },
        {
          name: "转换文件",
          children: [
            { name: "转换文件格式", pro: true, free: "●" }
          ]
        }
      ]
    },
    {
      name: "设置",
      children: [
        {
          name: "系统",
          children: [
            { name: "系统选项", pro: true, free: true },
            { name: "配置选项", pro: true, free: true },
            { name: "缩放镜头", pro: true, free: true }
          ]
        },
        {
          name: "模式",
          children: [
            { name: "序列模式", pro: true, free: true },
            { name: "非序列模式", pro: true, free: "●" }
          ]
        },
        {
          name: "编辑器",
          children: [
            { 
              name: "镜头编辑器", 
              pro: "最大100行，面型支持15类：标准面、近轴面、偶次非球面、环面、坐标间断、扩展多项式、多项式面、泽尼克标准相位、Toroidal NURBS、径向NURBS、Qtype面、衍射光栅、直角棱镜、二元面1、二元面2", 
              free: "最大30行，面型支持7类：标准面、近轴面、坐标间断、偶次非球面、环面、多项式面、扩展多项式面" 
            },
            { 
              name: "非序列元件编辑器", 
              pro: "最大20行，物体类型支持4类：标准透镜、反射面、光源、探测器", 
              free: "●" 
            },
            { name: "视场数据编辑器", pro: "最大25个", free: "最大3个" },
            { name: "多重结构编辑器", pro: "最大30个", free: "最大3个" },
            { name: "评价函数编辑器", pro: true, free: true },
            { name: "公差数据编辑器", pro: true, free: true },
            { name: "波长编辑器", pro: "最大30个", free: "最大3个" }
          ]
        }
      ]
    },
    {
      name: "分析",
      children: [
        {
          name: "视图",
          children: [
            { name: "2D视图", pro: true, free: true },
            { name: "3D视图", pro: true, free: true },
            { name: "实体模型", pro: true, free: true },
            { name: "元件制图", pro: true, free: "●" },
            { name: "CAD零件查看", pro: true, free: "●" }
          ]
        },
        {
          name: "成像质量",
          children: [
            { name: "单光线追迹", pro: true, free: true },
            { name: "光线像差图", pro: true, free: true },
            { name: "标准点列图", pro: true, free: true },
            { name: "光迹图", pro: true, free: true },
            { name: "离焦点列图", pro: true, free: true },
            { name: "全视场点列图", pro: true, free: true },
            { name: "矩阵点列图", pro: true, free: true },
            { name: "结构矩阵点列图", pro: true, free: true },
            { name: "入射角 vs.像高", pro: true, free: true },
            { name: "光线像差图", pro: true, free: true },
            { name: "光程差图", pro: true, free: true },
            { name: "光瞳像差", pro: true, free: true },
            { name: "场曲/畸变", pro: true, free: true },
            { name: "网格畸变", pro: true, free: true },
            { name: "轴向像差", pro: true, free: true },
            { name: "垂轴色差", pro: true, free: true },
            { name: "色焦移", pro: true, free: true },
            { name: "赛德尔系数", pro: true, free: true },
            { name: "赛德尔图", pro: true, free: true },
            { name: "光程差图", pro: true, free: true },
            { name: "波前图", pro: true, free: true },
            { name: "Zernike Fringe系数", pro: true, free: true },
            { name: "Zernike Standard系数", pro: true, free: true },
            { name: "FFT PSF", pro: true, free: true },
            { name: "FFT PSF截面图", pro: true, free: true },
            { name: "惠更斯PSF", pro: true, free: true },
            { name: "对比度损失图", pro: true, free: true },
            { name: "FFT MTF", pro: true, free: true },
            { name: "三维FFT MTF", pro: true, free: true },
            { name: "FFT MTF vs.视场", pro: true, free: true },
            { name: "二维视场FFT MTF", pro: true, free: true },
            { name: "惠更斯MTF", pro: true, free: true },
            { name: "二维惠更斯MTF", pro: true, free: true },
            { name: "几何MTF", pro: true, free: true },
            { name: "离焦几何MTF", pro: true, free: true },
            { name: "几何MTF vs.视场", pro: true, free: true },
            { name: "二维视场几何IMTF", pro: true, free: true },
            { name: "离焦MTF解析解", pro: true, free: true },
            { name: "RMS vs.视场", pro: true, free: true },
            { name: "RMS vs. 波长", pro: true, free: true },
            { name: "RMS vs.离焦", pro: true, free: true },
            { name: "二维视场RMS图", pro: true, free: true },
            { name: "衍射/几何", pro: true, free: true },
            { name: "几何线/边缘扩展", pro: true, free: true },
            { name: "图像模拟", pro: true, free: true },
            { name: "相对照度", pro: true, free: true },
            { name: "批量成像模拟", pro: true, free: "●" },
            { name: "像质提升", pro: true, free: "●" }
          ]
        },
        {
          name: "偏振与表面物理",
          children: [
            { name: "偏振光线追迹", pro: true, free: true },
            { name: "偏振光瞳图", pro: true, free: true },
            { name: "透过率计算", pro: true, free: true },
            { name: "偏振相位像差", pro: true, free: true },
            { name: "光瞳透过率", pro: true, free: true },
            { name: "矢高表", pro: true, free: true },
            { name: "矢高图", pro: true, free: true },
            { name: "相位", pro: true, free: true },
            { name: "曲率图", pro: true, free: true },
            { name: "表面斜率", pro: true, free: true },
            { name: "矢高载面图", pro: true, free: true },
            { name: "相位截面图", pro: true, free: true },
            { name: "曲率截面图", pro: true, free: true },
            { name: "斜率截面", pro: true, free: true },
            { name: "反射率 vs.角度", pro: true, free: true },
            { name: "透过率 vs.角度", pro: true, free: true },
            { name: "吸收率 vs.角度", pro: true, free: true },
            { name: "双衰减 vs角度", pro: true, free: true },
            { name: "相位 vs.角度", pro: true, free: true },
            { name: "相位延迟 vs角度", pro: true, free: true },
            { name: "反射率 vs.波长", pro: true, free: true },
            { name: "透过率 vs.波长", pro: true, free: true },
            { name: "吸收率 vs. 波长", pro: true, free: true },
            { name: "双衰减 vs波长", pro: true, free: true },
            { name: "相位 vs. 波长", pro: true, free: true },
            { name: "相位延迟 vs波长", pro: true, free: true }
          ]
        },
        {
          name: "报告",
          children: [
            { name: "表面数据报告", pro: true, free: true },
            { name: "系统数据报告", pro: true, free: true },
            { name: "分类数据报告", pro: true, free: true },
            { name: "系统数据摘要", pro: true, free: true },
            { name: "基面数据", pro: true, free: true }
          ]
        },
        {
          name: "应用分析",
          children: [
            { name: "鬼像分析", pro: true, free: true },
            { name: "鬼点分析", pro: true, free: true },
            { name: "非序列3D视图", pro: true, free: "●" },
            { name: "非序列实体模型", pro: true, free: "●" },
            { name: "非序列物体查看器", pro: true, free: "●" },
            { name: "光线追迹", pro: true, free: "●" },
            { name: "探测器查看器", pro: true, free: "●" },
            { name: "光线数据库查看器", pro: true, free: "●" },
            { name: "路径分析", pro: true, free: "●" }
          ]
        }
      ]
    },
    {
      name: "优化",
      children: [
        {
          name: "自动优化",
          children: [
            { name: "评价函数编辑器", pro: true, free: true },
            { name: "优化向导", pro: true, free: true },
            { name: "执行优化", pro: true, free: true },
            { name: "移除所有变量", pro: true, free: true },
            { name: "设全部半径为变量", pro: true, free: true },
            { name: "设全部厚度为变量", pro: true, free: true }
          ]
        },
        {
          name: "全局优化",
          children: [
            { name: "全局优化", pro: true, free: "●" },
            { name: "锤形优化", pro: true, free: "●" }
          ]
        },
        {
          name: "优化工具",
          children: [
            { name: "寻找最佳非球面", pro: true, free: "●" }
          ]
        }
      ]
    },
    {
      name: "公差",
      children: [
        {
          name: "公差分析",
          children: [
            { name: "公差数据编辑器", pro: true, free: true },
            { name: "公差分析向导", pro: true, free: true },
            { name: "公差分析", pro: true, free: true },
            { name: "公差报告", pro: true, free: true }
          ]
        }
      ]
    },
    {
      name: "数据库",
      children: [
        {
          name: "光学材料",
          children: [
            { name: "材料库", pro: true, free: true }
          ]
        },
        {
          name: "库存镜头",
          children: [
            { name: "镜头库", pro: true, free: true }
          ]
        },
        {
          name: "膜层",
          children: [
            { name: "膜层库", pro: true, free: true }
          ]
        }
      ]
    },
    {
      name: "编程",
      children: [
        {
          name: "编程",
          children: [
            { name: "宏列表", pro: true, free: "●" },
            { name: "编辑/执行", pro: true, free: "●" }
          ]
        }
      ]
    },
    {
      name: "帮助",
      children: [
        {
          name: "信息",
          children: [
            { name: "关于几何光学仿真", pro: true, free: true },
            { name: "许可证协议", pro: true, free: true }
          ]
        },
        {
          name: "文档",
          children: [
            { name: "用户指南", pro: true, free: true }
          ]
        }
      ]
    }
  ];

  // 展平树形数据并计算行合并参数
  const flattenFeatures = () => {
    interface FeatureRow {
      rowNumber: number;
      categoryName: string | null;
      categoryRowSpan: number | null;
      subcategoryName: string | null;
      subcategoryRowSpan: number | null;
      itemName: string;
      pro: boolean | string;
      free: boolean | string;
    }
    const rows: FeatureRow[] = [];
    let rowNumber = 1;

    features.forEach((category) => {
      // 计算一级分类的总行数
      const categoryRowSpan = category.children.reduce(
        (sum, subcat) => sum + subcat.children.length,
        0
      );

      category.children.forEach((subcat, subcatIndex) => {
        const subcatRowSpan = subcat.children.length;

        subcat.children.forEach((item, itemIndex) => {
          rows.push({
            rowNumber: rowNumber++,
            categoryName: subcatIndex === 0 && itemIndex === 0 ? category.name : null,
            categoryRowSpan: subcatIndex === 0 && itemIndex === 0 ? categoryRowSpan : null,
            subcategoryName: itemIndex === 0 ? subcat.name : null,
            subcategoryRowSpan: itemIndex === 0 ? subcatRowSpan : null,
            itemName: item.name,
            pro: item.pro,
            free: item.free,
          });
        });
      });
    });

    return rows;
  };

  const versions = [
    {
      name: "专业版",
      icon: Beaker,
      color: "bg-blue-500",
      price: "",//价格
      period: "",//时间
      description: "专为科研团队和研究机构设计，提供强大的光学数据分析能力",
      highlights: [
        "24/7专属支持",
        "API完全访问"
      ],
      popular: true
    },
    {
      name: "免费版",
      icon: GraduationCap,
      color: "bg-green-500",
      price: "",
      period: "",
      description: "适合教学使用，为师生提供必要的实验和分析功能",
      highlights: [
        "基础分析工具",
        "教学模板库"
      ],
      popular: false
    }
  ];

  const renderValue = (value: boolean | string) => {
    if (typeof value === 'boolean') {
      return value ? (
        <Check className="size-5 text-green-600 mx-auto" />
      ) : (
        <X className="size-5 text-gray-300 mx-auto" />
      );
    }
    return (
      <span className="text-sm text-center break-words whitespace-pre-wrap">
        {value}
      </span>
    );
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 py-12 px-4">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            选择适合您的版本
          </h1>
          <p className="text-xl text-gray-600">
            专业版与免费版功能对比，找到最适合您需求的解决方案
          </p>
        </div>

        {/* Version Cards */}
        <div className="grid md:grid-cols-2 gap-8 mb-16">
          {versions.map((version) => {
            const Icon = version.icon;
            return (
              <Card key={version.name} className={`relative ${version.popular ? 'border-2 border-blue-500 shadow-xl' : ''}`}>
                {version.popular && (
                  <div className="absolute -top-4 left-1/2 -translate-x-1/2">
                    <Badge className="bg-blue-500 text-white px-4 py-1">
                      推荐
                    </Badge>
                  </div>
                )}
                <CardHeader>
                  <div className="flex items-center gap-3 mb-2">
                    <div className={`${version.color} p-3 rounded-lg`}>
                      <Icon className="size-6 text-white" />
                    </div>
                    <CardTitle className="text-2xl">{version.name}</CardTitle>
                  </div>
                  <CardDescription className="text-base">
                    {version.description}
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <div className="mb-6">
                    <div className="flex items-baseline gap-1 mb-4">
                      <span className="text-4xl font-bold text-gray-900">
                        {version.price}
                      </span>
                      <span className="text-gray-600">{version.period}</span>
                    </div>
                    <Button 
                      className="w-full"
                      variant={version.popular ? "default" : "outline"}
                      onClick={() => {
                        if (version.popular) {
                          navigate('/contact');
                        } else {
                          navigate('/trial');
                        }
                      }}
                    >
                      {version.popular ? "联系我们" : "立即下载"}
                    </Button>
                  </div>
                  
                  <div className="space-y-3">
                    <p className="font-semibold text-sm text-gray-700">核心特性：</p>
                    {version.highlights.map((highlight, idx) => (
                      <div key={idx} className="flex items-start gap-2">
                        <Check className="size-5 text-green-600 flex-shrink-0 mt-0.5" />
                        <span className="text-sm text-gray-700">{highlight}</span>
                      </div>
                    ))}
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Detailed Comparison Table */}
        <Card>
          <CardHeader>
            <CardTitle className="text-2xl">详细功能对比</CardTitle>
            <CardDescription>
              完整的功能列表对比，帮助您做出明智的选择
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="overflow-x-auto">
              <table className="w-full border-collapse border border-gray-300">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border border-gray-300 py-3 px-4 font-semibold text-gray-900 text-center w-12">
                      序号
                    </th>
                    <th className="border border-gray-300 py-3 px-4 font-semibold text-gray-900 text-center">
                      一级分类
                    </th>
                    <th className="border border-gray-300 py-3 px-4 font-semibold text-gray-900 text-center">
                      二级分类
                    </th>
                    <th className="border border-gray-300 py-3 px-4 font-semibold text-gray-900 text-center">
                      三级功能项
                    </th>
                    <th className="border border-gray-300 py-3 px-4 font-semibold text-gray-900 text-center bg-blue-50 max-w-[250px]">
                      <div className="flex items-center justify-center gap-2">
                        <Beaker className="size-5 text-blue-600" />
                        专业版
                      </div>
                    </th>
                    <th className="border border-gray-300 py-3 px-4 font-semibold text-gray-900 text-center bg-green-50 max-w-[250px]">
                      <div className="flex items-center justify-center gap-2">
                        <GraduationCap className="size-5 text-green-600" />
                        免费版
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {flattenFeatures().map((row, idx) => (
                    <tr key={idx} className="hover:bg-gray-50 h-8">
                      <td className="border border-gray-300 py-2 px-3 text-center text-gray-700 text-sm align-middle">
                        {row.rowNumber}
                      </td>
                      {row.categoryName && (
                        <td
                          rowSpan={row.categoryRowSpan}
                          className="border border-gray-300 py-2 px-3 text-gray-700 font-medium text-center align-middle"
                        >
                          {row.categoryName}
                        </td>
                      )}
                      {row.subcategoryName && (
                        <td
                          rowSpan={row.subcategoryRowSpan}
                          className="border border-gray-300 py-2 px-3 text-gray-700 text-center align-middle"
                        >
                          {row.subcategoryName}
                        </td>
                      )}
                      <td className="border border-gray-300 py-2 px-3 text-gray-700 text-center align-middle max-w-[300px] break-words">
                        {row.itemName}
                      </td>
                      <td className="border border-gray-300 py-2 px-3 bg-blue-50/30 text-center align-middle max-w-[250px] break-words">
                        <div className="flex items-center justify-center min-h-[30px]">
                          {renderValue(row.pro)}
                        </div>
                      </td>
                      <td className="border border-gray-300 py-2 px-3 bg-green-50/30 text-center align-middle max-w-[250px] break-words">
                        <div className="flex items-center justify-center min-h-[30px]">
                          {renderValue(row.free)}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </CardContent>
        </Card>

        {/* Additional Info Icons */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-12">
          <div className="text-center">
            <div className="bg-purple-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-3">
              <Shield className="size-8 text-purple-600" />
            </div>
            <h3 className="font-semibold text-gray-900 mb-1">安全可靠</h3>
            <p className="text-sm text-gray-600">企业级数据加密</p>
          </div>
          <div className="text-center">
            <div className="bg-orange-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-3">
              <Cpu className="size-8 text-orange-600" />
            </div>
            <h3 className="font-semibold text-gray-900 mb-1">高性能</h3>
            <p className="text-sm text-gray-600">快速数据处理</p>
          </div>
          <div className="text-center">
            <div className="bg-cyan-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-3">
              <Users className="size-8 text-cyan-600" />
            </div>
            <h3 className="font-semibold text-gray-900 mb-1">团队协作</h3>
            <p className="text-sm text-gray-600">实时同步更新</p>
          </div>
          <div className="text-center">
            <div className="bg-pink-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-3">
              <HeadphonesIcon className="size-8 text-pink-600" />
            </div>
            <h3 className="font-semibold text-gray-900 mb-1">专业支持</h3>
            <p className="text-sm text-gray-600">全天候服务</p>
          </div>
        </div>

        
      </div>
    </div>
  );
}

